// General
import React, { useContext } from "react";
// Styles
import { Modal } from "react-bootstrap";
import { TextField, MenuItem } from "@mui/material";
// Formik
import { Formik, Form } from "formik";
// Contexts
import { DealersContext } from "../../data/dealers/DealersContex";
import { useValidations } from "../../data/ValidationContext";



const DealersAddModal = ({ isOpen, onClose }) => {
  // Contextten bayi listesi ve ekleme fonksiyonunu al
  const { dealersList, addDealer } = useContext(DealersContext);
  // Formik validation şeması
  const { vs_dealer } = useValidations();

  // Formik için başlangıç değerleri
  const initialValues = { name: "", status: "Aktif" };

  return (
    <Modal show={isOpen} onHide={onClose} centered backdrop="static">
      {/* Formik setup */}
      <Formik
        initialValues={initialValues}
        validationSchema={vs_dealer}
        onSubmit={(values) => {
          // Bayi ekle
          addDealer(values);
          // Modal kapat
          onClose();
        }}
      >
        {({ values, errors, touched, handleChange }) => (
          <Form>
            {/* Modal Header */}
            <Modal.Header closeButton>
              <Modal.Title>Bayi Ekle</Modal.Title>
            </Modal.Header>

            {/* Modal Body */}
            <Modal.Body>
              {/* Bayi Adı */}
              <div className="mb-3">
                <TextField
                  label="Bayi Adı"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  error={touched.name && !!errors.name}
                  helperText={touched.name && errors.name}
                />
              </div>

              {/* Durum Seçimi */}
              <div>
                <TextField
                  select
                  label="Durum"
                  name="status"
                  value={values.status}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  error={touched.status && !!errors.status}
                  helperText={touched.status && errors.status}
                >
                  <MenuItem value="Aktif">Aktif</MenuItem>
                  <MenuItem value="Pasif">Pasif</MenuItem>
                </TextField>
              </div>
            </Modal.Body>

            {/* Modal Footer */}
            <Modal.Footer>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Kaydet
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default DealersAddModal;
